module.exports = __webpack_public_path__ + "img/alert.83af796b.svg";